import { GameEvent, GameEventType } from "./GameEvent";

export class GamePoint {
  constructor(
    public pointNumber: number,
    public pullingTeam: string,
    public receivingTeam: string,
    public pullingTeamScoreAtStartOfPoint: number,
    public receivingTeamScoreAtStartOfPoint: number,
    public pullingTeamEvents: GameEvent[],
    public receivingTeamEvents: GameEvent[],
    public scoringTeam: string | null,
  ) {}

  static createPoint(
    pointNumber: number,
    pullingTeam: string,
    receivingTeam: string,
  ): GamePoint {
    return new GamePoint(
      pointNumber,
      pullingTeam,
      receivingTeam,
      0,
      0,
      [],
      [],
      null,
    );
  }

  addPullingTeamEvent(event: GameEvent) {
    this.pullingTeamEvents.push(event);
    if (event.eventType === GameEventType.GOAL) {
      this.scoringTeam = event.teamId;
    }
  }

  addReceivingTeamEvent(event: GameEvent) {
    this.receivingTeamEvents.push(event);
    if (event.eventType === GameEventType.GOAL) {
      this.scoringTeam = event.teamId;
    }
  }
}
